<template>
  <div class="dx-wrap" :class="{wrong: isWrong}">
    <div class="question">
      <i v-if="isListen" class="iconfont icon-voice" @click="listen(testbank.audioUrl)"></i>
      <span v-else>{{testbank.question}}</span>
    </div>
    <div class="answers">
      <div class="item" v-for="(option,index) in testbank.options" :key="index">
        <el-radio
          v-model="answer"
          :label="index"
          @change="changeAnswer"
          :disabled="isFinish"
          :class="{'right-answer':showRightAnswer(index)}"
        >
          {{option}}
          <!-- <span
            class="text"
            :class="{'right-answer':showRightAnswer(index)}"
          >{{option}}</span> -->
        </el-radio>
      </div>
    </div>
  </div>
</template>
<script>
import { Radio } from 'element-ui';
import AudioPlayer from '@/services/audio-player';

export default {
  components: {
    ElRadio: Radio,
  },
  props: {
    testbank: {
      type: Object,
      default() {
        return null;
      },
    },
    isListen: {
      type: Boolean,
      default: false,
    },
    isFinish: {
      type: Boolean,
      default: false,
      required: true,
    },
    typeName: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {
    isWrong() {
      return this.answer !== this.testbank.answerIndex && this.isFinish;
    },
  },
  data() {
    return {
      answer: '',
    };
  },
  methods: {
    listen(url) {
      AudioPlayer.play(url);
    },
    changeAnswer() {
      const result = {
        typeName: this.typeName + this.testbank.id,
      };
      if (this.answer === this.testbank.answerIndex) {
        result.result = 1;
      } else {
        result.result = 0;
      }
      this.$emit('changeRadio', result);
    },
    showRightAnswer(index) {
      return this.isWrong && index === this.testbank.answerIndex;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.dx-wrap {
  .question {
    padding: 5px 10px;
    background: #f4f4f4;
    font-size: 24px;
    border: 1px solid $border-color;
    font-weight: bold;
    .iconfont {
      font-size: 24px;
      cursor:pointer;
    }
  }
  .answers {
    border-bottom: 1px solid $border-color;
    .item {
      /deep/ .el-radio {
        line-height: 42px;
        white-space: normal;
        .el-radio__label {
          font-size: 20px;
          width: 784px;
        }
      }
      .text{
        font-size: 20px;
        display: inline-block;
        width: 784px;
        white-space: normal;
        line-height: 30px;
      }
    }
  }
}
.wrong {
  .question {
    background: $danger;
    color: #fff;
    display: flex;
    flex-direction: row;
    align-content: center;
  }
  .answers {
    .item {
      /deep/ .right-answer {
        .el-radio__label{
          color: $danger;
        }
      }
    }
  }
}
</style>
